var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'calendar-item': true,
        'calendar-item--previous': _vm.isPreviousDay,
    },on:{"click":_vm.handleClick}},[(_vm.isNoData)?_c('NoData',{attrs:{"day":_vm.day}}):(_vm.isNotAvailable)?_c('NotAvailable',{attrs:{"day":_vm.day}}):(_vm.isSoldOut)?_c('SoldOut',{attrs:{"day":_vm.day}}):_c('Available',{attrs:{"day":_vm.day}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }